import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/account/license.account.query.gql"
import type {
  LicenseAccountsQuery,
  LicenseAccountsQueryVariables,
} from "@/v2-backoffice-client/license/account/__types__/license.account.query"

type Options = QueryHookOptions<
  LicenseAccountsQuery,
  LicenseAccountsQueryVariables
>

export function useLicenseAccountsQuery(options?: Options) {
  return useQuery<LicenseAccountsQuery, LicenseAccountsQueryVariables>(
    query,
    options,
  )
}
